import type React from "react";
import { Link } from "react-router-dom";

const Events: React.FC = () => {
	const events = [
		{
			id: "mokumoku",
			title: "もくもく会",
			description: "各自が自分の学習テーマに取り組む会",
			icon: "📚",
			link: "/mokumoku",
		},
		{
			id: "study-groups",
			title: "勉強会",
			description: "特定のテーマについて学ぶ会",
			icon: "👥",
			link: "/study-groups",
		},
		{
			id: "hackathon",
			title: "ハッカソン",
			description: "チームでプロジェクトに取り組むイベント",
			icon: "💻",
			link: "/hackathon",
		},
	];

	return (
		<section className="py-16 md:py-24 bg-white">
			<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
				<div className="text-center mb-12">
					<h2 className="text-3xl md:text-4xl font-bold mb-4">主なイベント</h2>
					<p className="text-lg text-gray-600">
						定期的に開催される学習イベント
					</p>
				</div>

				<div className="grid md:grid-cols-3 gap-8">
					{events.map((event) => (
						<Link
							key={event.id}
							to={event.link}
							className="group bg-gray-50 p-8 rounded-lg text-center hover:bg-gray-100 transition-colors"
						>
							<div className="text-4xl mb-4 group-hover:scale-110 transition-transform">
								{event.icon}
							</div>
							<h3 className="text-xl font-semibold mb-2">{event.title}</h3>
							<p className="text-gray-600">{event.description}</p>
						</Link>
					))}
				</div>
			</div>
		</section>
	);
};

export default Events;
